import {
	TimelineItemCategoryEnum,
	type TimelineItemResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const isUnreadNotification = (item: TimelineItemResponseDTO): boolean =>
	item.category === TimelineItemCategoryEnum.Notification && !item.isRead;
